import {Component, Input, OnInit, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';

@Component({
    selector: 'app-decision-details',
    templateUrl: './decision-details.component.html',
    styleUrls: ['./decision-details.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DecisionDetailsComponent implements OnInit {

    @Input() decision;
    @Input() filterText;
    @Input() expandAll;
    @Input() expand;
    currentSession;
    currentDoc;
    panelOpenState = false;
    constructor(private router: Router,
      private currentRoute: ActivatedRoute,
        private lookupService: IGAEADLookupService) {
    }

    ngOnInit(): void {
      this.currentSession = this.currentRoute.snapshot.paramMap.get('sessionID');
      this.currentDoc = this.currentRoute.snapshot.queryParamMap.get('document');
      if(this.expandAll){
        this.panelOpenState =true;
      }
      else if(this.decision.isDocExist){
        this.panelOpenState =true;
      }
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(this.expandAll){
        this.panelOpenState =true;
      }else{
        this.panelOpenState =false;
      }
    }

    public openPage(name: string): void {
        this.router.navigate([name], {});
    }

    getTitle(params){
        return `${params.ED_DecisionNumber } ${params.ED_Title }`;
        //return `${date + " " + params.MT_body}`;
    }

    getDocument(docs){
      let title = [];
      if(docs){
        for(let doc of docs){
            title.push(`<a href="https://undocs.org/${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a> <a href="${EnvironmentLoader.environment.localURL}/ga/${this.currentSession}/meetings?document=${doc.DD_symbol1}" > <i class="fa fa-external-link"></i></a>`)
        }
      }
      return title.join(', ');
  }

    journalUrl(MT_JCMSMeetingID){
      return EnvironmentLoader.environment.journalUrl + MT_JCMSMeetingID
    }

    pvLink(meetingNo){
      return `https://undocs.org/A/${this.currentSession}/PV.${meetingNo}`
    }

    getLisofSpeakers(speakers) {
      let _spekers = [];
      for(let speaker of speakers){
        _spekers.push(speaker.SP_entity.SP_entity);
      }
      return _spekers.join(',');
    }
    getSymbols(documents){
        let links = [];
        if(documents){
          for(let document of documents){
            links.push(`<a hreg="https://undocs.org/${document.DD_symbol1}" target="_blank" >${document.DD_symbol1}</a>`)
          }
          return links.join(',');
        }
        return '';
    }

    getMeetingReference(id) {
      return EnvironmentLoader.environment.meetingReference + id;
    }

    changeAccordianState() {
      this.panelOpenState = !this.panelOpenState;
    }
}
